module.exports = __webpack_public_path__ + "img/img23.c57d98b3.svg";